"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var component_registry_1 = __importDefault(require("./component_registry"));
var translate_1 = __importDefault(require("./translate"));
var directive_1 = __importDefault(require("./directive"));
var change_language_1 = __importDefault(require("./change_language"));
;
function mixin(componentRegistry, state, translate, changeLanguage) {
    return {
        directives: {
            t: directive_1.default,
            translate: directive_1.default,
        },
        data: function () {
            return state;
        },
        computed: {
            $lang: function () {
                return state.$currentLang;
            },
        },
        methods: {
            $t: translate,
            $setLang: changeLanguage,
        },
        beforeCreate: function () {
            componentRegistry.add(this);
        },
        destroyed: function () {
            componentRegistry.delete(this);
        },
    };
}
exports.mixin = mixin;
exports.default = mixin(component_registry_1.default, state_1.default, translate_1.default, change_language_1.default);
//# sourceMappingURL=mixin.js.map